import { FC, useState } from "react";

import { useApi } from "../../api";
import { Button } from "../../ui/layout/molecules/Button";
import { useCounter } from "../hooks";
import { ErrorWrapper } from "../wrappers";
import { LoaderIcon } from "../../ui/icons";
import { CENTERED_COLUMN_CLASSNAME } from "../general";

const BUTTON_STYLE = "flex items-center justify-center w-full";

export const VERIFICATION_EMAIL_ERROR_MESSAGE =
  "There is an error in sending the verification email, please try again later.";
const COUNTER_LIMIT = 60;

export const VerifyForm: FC<React.PropsWithChildren> = () => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");

  const { isCounting, counter, setCounter } = useCounter(COUNTER_LIMIT);

  const { getApi } = useApi();

  const sendVerificationEmail = async () => {
    setErrorMessage("");
    setLoading(true);
    try {
      const api = await getApi();
      if (!api) return;

      await api.sendVerificationEmail();
    } catch (err) {
      setErrorMessage(VERIFICATION_EMAIL_ERROR_MESSAGE);
    }
    setCounter(COUNTER_LIMIT);
    setLoading(false);
  };

  return (
    <ErrorWrapper errorMessage={errorMessage}>
      <div className={CENTERED_COLUMN_CLASSNAME}>
        <div className="mb-4 dark:text-white">
          To verify your email, please check your inbox (double check junk mail
          folder too)
        </div>

        <div className="mt-4">
          {loading ? (
            <div className="flex justify-center">
              <LoaderIcon className="animate-spin" />
            </div>
          ) : (
            <Button
              buttonType="secondary"
              title={`Please send verification email again ${
                isCounting ? counter : ""
              }`}
              className={BUTTON_STYLE}
              onClick={sendVerificationEmail}
              capitalize={false}
              disabled={isCounting}
            />
          )}
        </div>
      </div>
    </ErrorWrapper>
  );
};
